import { Box, Grid, Hidden, Card, CardContent } from "@material-ui/core";
import { QuoteLineItem } from "../../../api/Quote/QuoteLineItem";
import { Quote } from "../../../api/Quote/Quote";
import { quoteAmountWithOutAddons, quoteImage, quoteQuantity } from "../../../app/utils";
import QuoteCartAddonSelected from "./QuoteCartAddonSelected";
import QuoteCartRightAction from "./QuoteCartRightAction";
import QuoteCartAddonLeftPreview from "./QuoteCartAddonLeftPreview";
import { QuoteHr } from "../../quotePage/components/QuoteHr";
import QuoteCartProductSubscription from "./QuoteCartProductSubscription";
import { ProductSubscription } from "../../../api/Product/ProductSubscriptionApi";
import { EventSlot } from "../../../api/EventSlot/EventSlot";

const QuoteCartContent = ({
  quote,
  onChangeQuantity,
  onRemoveAddon,
  subscriptions,
  onRemoveSubscription,
  onAddSubscription,
  selectedEventSlot,
  onPay,
  onApplyPromoCode,
  onDeletePromoCode
}: Props) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Box textAlign="center" fontSize="1.5rem" fontWeight="fontWeightBold" p={3}>
          Quote summary
        </Box>
      </Grid>
      <Grid item md={7} xs={12}>
        <QuoteCartAddonLeftPreview
          name={quote.title}
          image={quoteImage(quote)}
          price={quoteAmountWithOutAddons(quote)}
          quantity={quoteQuantity(quote)}
        />
        <QuoteCartAddonSelected
          onRemoveAddon={onRemoveAddon}
          addons={quote.addons}
          onChangeQuantity={onChangeQuantity}
        />
        <Hidden mdDown>
          <QuoteCartProductSubscription
            quote={quote}
            subscriptions={subscriptions}
            onRemoveSubscription={onRemoveSubscription}
            onAddSubscription={onAddSubscription}
          />
        </Hidden>
        <Hidden lgUp>
          <QuoteHr mt={2} mb={2} />
          <QuoteCartRightAction
            quote={quote}
            subscriptions={subscriptions}
            onRemoveSubscription={onRemoveSubscription}
            onAddSubscription={onAddSubscription}
            selectedEventSlot={selectedEventSlot}
            onPay={onPay}
            onApplyPromoCode={onApplyPromoCode}
            onDeletePromoCode={onDeletePromoCode}
          />
        </Hidden>
      </Grid>
      <Hidden mdDown>
        <Grid item md={5} xs={12}>
          <Card square>
            <CardContent>
              <QuoteCartRightAction
                quote={quote}
                subscriptions={subscriptions}
                onRemoveSubscription={onRemoveSubscription}
                onAddSubscription={onAddSubscription}
                selectedEventSlot={selectedEventSlot}
                onPay={onPay}
                onApplyPromoCode={onApplyPromoCode}
                onDeletePromoCode={onDeletePromoCode}
              />
            </CardContent>
          </Card>
        </Grid>
      </Hidden>
    </Grid>
  );
};

export default QuoteCartContent;

interface Props {
  quote: Quote;
  onChangeQuantity: (addon: QuoteLineItem, quantity: number) => void;
  onRemoveAddon: (addon: QuoteLineItem) => void;
  subscriptions?: ProductSubscription[];
  onRemoveSubscription: (subscription: ProductSubscription) => void;
  onAddSubscription: (subscription: ProductSubscription) => void;
  selectedEventSlot?: EventSlot | null;
  onPay: Function;
  onApplyPromoCode: (promoCode: string) => void;
  onDeletePromoCode: (quoteDeductionId: string) => void;
}
